import React from 'react';
import { Redirect } from 'react-router-dom';

// Helper function to check permission and conditionally redirect
const AuthenticatedRoute = (permissions, requiredPermission) => {
    if (permissions && !permissions.includes(requiredPermission)) {
        return <Redirect to='/401' />;
    }
    return null; // Return null if permission is valid (no redirect)
};

export default AuthenticatedRoute;
